// removed by extract-text-webpack-plugin
module.exports = {"container":"_1rDsdvK7FrfDsPZq83tbX0","titleContainer":"_2Xtt8WIiYKMm-8_Y1tQ-2z","caret":"_2GfFs_7KJBmrgiCnhXGAOm","collapsed":"_2t-UN0Yvktpy6k0nXe7DXd","list":"_9wVkcVCzqs5PsqvZzJuLD","menuIcon":"_14lLYr9rXJ9fDs4sVAxViD","menuLabel":"_3VFux6SDGMtBSMmKJvK1pM","homePage":"_3rNio6PM1KIOMtK0nd6qNl","homesResult":"DFw5jElb1Wmy8ICZU0p7e","collapsedManageProperties":"_1BPwnaUdiUzyEnRYN_ELe5"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MenuDropdownProperty/MenuDropdownProperty.scss
// module id = 1634
// module chunks = 0